"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALE = exports.LOCALE_HEADER = exports.ResponseType = exports.SUPPORTED_MEDIA_TYPE = void 0;
var SUPPORTED_MEDIA_TYPE;
(function (SUPPORTED_MEDIA_TYPE) {
    SUPPORTED_MEDIA_TYPE["APPLICATION_JSON"] = "application/json";
    SUPPORTED_MEDIA_TYPE["JSON_LINES_MIMETYPE_FOR_STREAM"] = "application/x-ndjson";
    SUPPORTED_MEDIA_TYPE["CSV"] = "text/csv";
})(SUPPORTED_MEDIA_TYPE || (exports.SUPPORTED_MEDIA_TYPE = SUPPORTED_MEDIA_TYPE = {}));
var ResponseType;
(function (ResponseType) {
    ResponseType["JSON"] = "json";
    ResponseType["CSV"] = "csv";
})(ResponseType || (exports.ResponseType = ResponseType = {}));
exports.LOCALE_HEADER = 'idf-locale';
var LOCALE;
(function (LOCALE) {
    LOCALE["en_CA"] = "en-CA";
    LOCALE["en_US"] = "en-US";
    LOCALE["fr_CA"] = "fr-CA";
    LOCALE["fr_FR"] = "fr-FR";
})(LOCALE || (exports.LOCALE = LOCALE = {}));
